import { motion } from 'framer-motion';
import nouveaute from '../assets/images/NouveauteHoraireContinu.png';

const SplashScreen = ({ onFinish }) => {
  return (
    <motion.div
      className="fixed inset-0 bg-white flex items-center justify-center z-50"
      initial={{ opacity: 1 }}
      animate={{ opacity: 0 }}
      transition={{ duration: 2, delay: 3 }}
      onAnimationComplete={onFinish}
    >
      <motion.img
        src={nouveaute}
        alt="nouveaute Groupe Scolaire Sanaa"
        className="w-full h-screen object-contain p-4" // Modifications ici
        initial={{ scale: 0.9 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1 }}
        style={{ 
          maxWidth: '100%',
          maxHeight: '100vh',
        }}
      />
    </motion.div>
  );
};

export default SplashScreen;